module.exports = __webpack_public_path__ + "static/media/icon-folder.b76d31f5.svg";